module.exports = __webpack_public_path__ + "img/NHBQR1.40b9825a.svg";